import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Section } from 'src/app/model/shared/section';
import { ModalComponent } from '../../shared/modal/modal.component';

@Component({
  selector: 'app-revision-notices-xml-modal-section',
  templateUrl: './revision-notices-xml-modal-section.component.html',
  styleUrls: ['./revision-notices-xml-modal-section.component.scss']
})
export class RevisionNoticesXmlModalSectionComponent implements OnInit {
  @Input() sections: Section[] = [];

  @ViewChild('modal') modal!: ModalComponent;

  eventListenersAdded: boolean = false;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.modal && this.modal.close();
    this.eventListenersAdded = false;
  }

  ngAfterViewChecked(): void {
    let elements = (<HTMLElement>this.elementRef.nativeElement).querySelectorAll('.xmlModal');

    // // console.log('elements : ', elements.length);

    if (elements.length > 0 && !this.eventListenersAdded) {
      this.eventListenersAdded = true;

      // // console.log('eventListenersAdded : ', this.eventListenersAdded);

      elements.forEach((element) =>
        this.renderer.listen(element, 'click', () => {
          // console.log('title : ', element.getAttribute('title'));
          this.modal.open(element.getAttribute('title') || '');
        })
      );
    }
  }
}
